/** 计算TTI轮训时间 */
export const BASE_TIME = 1000

/** 超出则上报的资源最大加载时长 */
export const TIMEOUT = 300

export const MAX_TTI = 10000
